export const API_ROUTES = {
  CALCULATE_SHIPPING: 'v1/shipping/calculate',
  PRINT_SHIPPING: 'v1/shipping/print',
  ORDER: 'v1/order',
  ORDER_REVIEW: 'v1/order/review',
  ORDER_REFUND: 'v1/order/refund',
  PAGARME_RECIPIENT: 'v1/pagarme/recipient',
  PAGARME_BIN: 'v1/pagarme/bin',
  PAGARME_BALANCE: 'v1/pagarme/balance',
  PAGARME_WITHDRAW: 'v1/pagarme/withdraw',
  BANK: 'v1/bank',
  CHAT: 'v1/chat',
  CHAT_MESSAGE: 'v1/chat/message',
  MEILISEARCH_SEARCH: 'v1/search',
  KYC_PAGARME: 'v1/kyc-pagarme',
};

export const MAIN = 'app';
export const AUTH = 'auth';
export const REGISTER = 'register';
export const HOME = {
  BASE: 'home',
};

export const SELL = {
  BASE: 'sell',
  CATEGORIES: 'categories',
  PUBLISH: 'publish',
  EDIT: 'edit',
  SUCCESS: 'success',
  DETAIL: 'detail',
};

export const CART = {
  BASE: 'cart',
  SHIPPING: 'shipping',
};

export const PAYMENT = {
  BASE: 'payment',
  METHOD: 'method',
  BOLETO: 'boleto',
  CREDIT_CARD: 'credit-card',
};

export const NOTIFICATIONS = {
  BASE: 'notifications',
};

export const PROFILE = {
  BASE: 'profile',
};

export const ACCOUNT = {
  BASE: 'account',
  BANK: 'bank',
  KYC: 'kyc-pagarme',
};

export const ADDRESS = {
  BASE: 'address',
};

export const FAQ = {
  BASE: 'faq',
};

export const SALES = {
  BASE: 'sales',
};

export const BANKING = {
  BASE: 'banking',
};

export const BOOST = {
  BASE: 'boost',
};

export const SEARCH = {
  BASE: 'search',
};

export const FAVORITES = {
  BASE: 'favorites',
};

export const ORDERS = {
  BASE: 'orders',
  REVIEW: 'review',
  REFUND: 'refund',
};

export const CHAT = {
  BASE: 'chat',
  MESSAGE: 'message',
};

export const VOUCHER = {
  BASE: 'voucher',
};

export const SUGGESTIONS = {
  BASE: 'suggestions',
};
